<template>
    <div id="login" @keyup.enter="submit()">
        <div v-if="!send">
            <p>Vul hieronder uw e-mailadres in waarmee u uw account geregistreerd heeft.</p>
            <p>U ontvangt van ons een activatielink om een nieuw wachtwoord aan te maken.</p>

            <div class="error" v-if="error">{{error}}</div>
            
            <div class="form-group" v-bind:class="{ 'form-group--error': $v.email.$error }">
                <label class="form__label">E-mail</label>
                <input class="form__input" v-model="email" type="email" @input="$v.email.$touch()">
            </div>
            <span class="form-group__message" v-if="!$v.email.email">Invalid e-mail</span>
            <span class="form-group__message" v-if="!$v.email.minLength">E-mail must have at least {{$v.email.$params.minLength.min}} letters.</span>
            
            <input class="button dub-button dub-button-space" type="submit" value="Stuur mij de link" @click="submit()"/>
        </div>
        <div v-else>
            <p>Wij hebben u een e-mail gestuurd. Deze bevat de gegevens om uw wachtwoord te kunnen wijzigen.</p>
            <router-link to="/">
                Naar inloggen
            </router-link>
        </div>
    </div>
</template>

<script>
    import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'
    
    export default {
    name: 'ForgotPassword',
        data () {
            return {
                email: '',
                error: false,
                send: false
            }
        },

        validations: {
            email:{
                required,
                email,
                minLength: minLength(5),
                maxLength: maxLength(100)
            }
        },

        mounted(){
            
            //Hide loading screen
            var root = this.$root;
            root.loading = false;
        },
        
        methods:{
            
            submit(){
                var email = this.email;
                var root = this.$root;
                
                root.loading = true;
                
                this.$api.post('/auth/forgot-password', {
                    email: email,
                })
                .then(response => {
                    
                    this.send = true;
            
                    setTimeout(function(){
                            
                        root.loading = false;
                        
                    }, 500);
                })
                .catch(e => {
                    
                    setTimeout(function(){
                            
                        root.loading = false;
                        
                    }, 500);
                    
                    
                    this.error = e.response.data.message;
                })
                
                this.email = '';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/auth/ForgotPassword.vue